import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import html2canvas from 'html2canvas';
import { createFileName } from '../utils/helpers';
import HeatmapViewableImage from './HeatmapViewableImage/HeatmapViewableImage';
import './HeatmapViewableImagesContainer.css';

function HeatmapViewableImagesContainer({ alignmentId, donorDevice2, setIsCollectingFiles }) {
  const twoHopSelectedRastersDictionary = useSelector(
    (store) => store.ui.actionsPage.twoHopSelectedRastersDictionary?.[alignmentId]
  );
  const deviceHeatmapHistoryDictionary = useSelector((store) => store.data.heatmapHistoryDictionary?.[donorDevice2]);
  const twoHopStatusInstanceDictionary = useSelector(
    (store) => store.ui.actionsPage?.twoHopStatusInstanceDictionary?.[alignmentId]
  );
  const twoHopRasterIdDictionary = useSelector(
    (store) => store.ui.actionsPage?.twoHopRasterIdDictionary?.[alignmentId]
  );
  const twoHopScoreDictionary = useSelector((store) => store.ui.actionsPage?.twoHopScoreDictionary?.[alignmentId]);
  const [selectedRasterIds, setSelectedRasterIds] = useState([
    { rasterId: null, rowKey: null },
    { rasterId: null, rowKey: null }
  ]);

  useEffect(() => {
    if (twoHopSelectedRastersDictionary) {
      let newSelectedRasterIds = [
        { rasterId: null, rowKey: null },
        { rasterId: null, rowKey: null }
      ];
      for (let rowKey of Object.keys(twoHopSelectedRastersDictionary)) {
        if (twoHopSelectedRastersDictionary[rowKey]) {
          if (newSelectedRasterIds[0].rasterId === null) {
            newSelectedRasterIds[0] = { rasterId: twoHopRasterIdDictionary[rowKey], rowKey };
          } else if (newSelectedRasterIds[1].rasterId === null) {
            newSelectedRasterIds[1] = { rasterId: twoHopRasterIdDictionary[rowKey], rowKey };
            break;
          }
        }
      }
      setSelectedRasterIds(newSelectedRasterIds);
    }
  }, [deviceHeatmapHistoryDictionary, twoHopSelectedRastersDictionary, twoHopRasterIdDictionary]);

  const handleSingleImageDownload = async (record) => {
    await setIsCollectingFiles(true);
    const fileName = createFileName(record);
    const exportBtnElement = document.getElementById(
      `HeatmapViewableImagesContainer_ExportDiv_ExportBtn_${record?.rasterId}`
    );
    exportBtnElement.style.display = 'none';

    const element = document.getElementById(`HeatmapViewableImagesContainer_HeatMapDiv_${record?.rasterId}`);
    const canvas = await html2canvas(element);
    const dataURL = canvas.toDataURL('image/jpg');
    const link = document.createElement('a');

    link.href = dataURL;
    link.download = `${fileName}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    exportBtnElement.style.display = 'block';
    setIsCollectingFiles(false);
  };

  return (
    <div
      className="HeatmapViewableImagesContainer_BackgroundHeatmapContainer"
      id="HeatmapViewableImagesContainer_BackgroundHeatmapContainer"
    >
      {selectedRasterIds.map(({ rasterId, rowKey }, index) =>
        rasterId != null ? (
          <HeatmapViewableImage
            key={rasterId}
            instance={twoHopStatusInstanceDictionary?.[rowKey]}
            az={twoHopStatusInstanceDictionary?.[rowKey]?.az ?? '00'}
            el={twoHopStatusInstanceDictionary?.[rowKey]?.el ?? '00'}
            score={twoHopScoreDictionary?.[rowKey] ?? '00'}
            donorDevice={donorDevice2}
            rasterId={rasterId}
            hidePopover={true}
            placeholder={false}
            handleSingleImageDownload={handleSingleImageDownload}
          />
        ) : (
          <HeatmapViewableImage
            key={index}
            customClassName={'HeatmapViewableImagesContainer_HeatMapDiv_Placeholder'}
            az={null}
            el={null}
            score={null}
            donorDevice={donorDevice2}
            beamrank={null}
            rasterId={rasterId}
            hidePopover={true}
            placeholder={true}
          />
        )
      )}
    </div>
  );
}

export default HeatmapViewableImagesContainer;
